<template>
  <div>
    <v-menu v-model="menu" :close-on-content-click="true" offset-y>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn class="mx-2 primary" v-on="tooltip" @click="LanguageOn">
          <flag :iso="flagName" v-bind:squared="false" />
          <span class="selected-lang">{{ locale }}</span>
        </v-btn>
      </template>
      <v-card>
        <v-list dense>
          <v-list-item-group v-model="menu" color="primary">
            <v-list-item
              v-for="(item, i) in languages"
              :key="i"
              @click="changeLocale(item.language)"
            >
              <div>
                <flag :iso="item.flag" v-bind:squared="false" />
                <span class="selected-lang">{{ item.language }}</span>
              </div>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import i18n from "../i18n";

function getFlagName(array, conditionFn) {
  const item = array.find(conditionFn);
  const x = array.indexOf(item);
  return array[x].flag;
}

export default {
  name: "Language",
  data() {
    return {
      locale: i18n.locale,
      menu: "",
      languages: [
        { language: "pl", flag: "pl" },
        { language: "en", flag: "gb" },
        { language: "cs", flag: "cz" },
        { language: "sk", flag: "sk" },
        { language: "de", flag: "de" },
        { language: "it", flag: "it" },
        { language: "fr", flag: "fr" }
      ],
      flagName: ""
    };
  },
  beforeCreate() {
    if (this.$cookies.isKey("TPLanguage") == true) {
      i18n.locale = this.$cookies.get("TPLanguage");
      window.Store.commit("changeLang", this.$cookies.get("TPLanguage"))
    } else {
      i18n.locale = navigator.language.substr(0, 2);
      window.Store.commit("changeLang", navigator.language.substr(0, 2))
    }
    if (!["pl", "en", "cs", "sk", "de", "it", "fr"].includes(i18n.locale))
      i18n.locale = "en";
      window.Store.commit("changeLang", "en")
  },
  beforeMount() {
    this.flagName = getFlagName(
      this.languages,
      item => item.language === i18n.locale
    )
    this.saveLang(i18n.locale)
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
      this.locale = locale;
      this.saveLang(locale)
      this.$cookies.set("TPLanguage", locale);
      this.flagName = getFlagName(
        this.languages,
        item => item.language === i18n.locale
      );
    },
    LanguageOn() {
      this.menu = true;
    },
    saveLang(lang){
      window.Store.commit("changeLang", lang)
    }
  }, 
  computed() {}
};
</script>

<style lang="scss">
.selected-lang {
  text-transform: uppercase;
  cursor: pointer;
  width: 100%;
  text-align: right;
  margin-left: 3px;
}
</style>    